import { render, staticRenderFns } from "./MyCallbacks.vue?vue&type=template&id=96400d1e&scoped=true&"
import script from "./MyCallbacks.vue?vue&type=script&lang=js&"
export * from "./MyCallbacks.vue?vue&type=script&lang=js&"
import style0 from "./MyCallbacks.vue?vue&type=style&index=0&id=96400d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96400d1e",
  null
  
)

export default component.exports